import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { JoinCostCenterCostCenterDialogModule } from './dialog/join-cost-center-cost-center-dialog.module';
import { GenericInputModule } from '@sla-ng/ui-material';
import { JoinCostCenterCostCenterDetailPage } from './join-cost-center-cost-center-detail.page';

export * from './join-cost-center-cost-center-detail.page';
export * from './dialog/join-cost-center-cost-center-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: JoinCostCenterCostCenterDetailPage,
    },
];

@NgModule({
    declarations: [ JoinCostCenterCostCenterDetailPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        TranslateModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatProgressBarModule,
        MatTableModule,
        MatTooltipModule,
        GenericInputModule,
        MatSelectModule,
        MatCheckboxModule,
        JoinCostCenterCostCenterDialogModule,
        MatSortModule,
        MatPaginatorModule,
        MatMomentDateModule
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
    ]

})
export class JoinCostCenterCostCenterDetailPageModule {
}
